import Migration from './migration'

import LocalForage from 'localforage'

import Logger from '@/logger'

export default class M005 extends Migration {

    constructor() {
        super('M005 - Drop projects table',
            async() => {
                try {
                    Logger.log('Attempting dropping instance...', 'Migrations')
                    await LocalForage.dropInstance({
                        name: 'pp-household',
                        storeName: 'projects',
                    })
                    Logger.log('Project table dropped', 'Migrations')
                } catch {
                    Logger.log('No project data to clear', 'Migrations')
                }
            })
    }
}
